import * as Reducer from './slice';

export interface AppState {
  // this feature state
  [Reducer.statePropName]: Reducer.IUnityState;
  // other features we don't care of
  [otherKeys: string]: any;
}

const getState = (state: AppState) => state[Reducer.statePropName];

export const isUnityStarted = (state: AppState) => getState(state).started;

export const getUnityProgress = (state: AppState) => getState(state).progress;

export const getCurrentExerciseName = (state: AppState) => getState(state).exerciseName;

export const isWorkoutRunning = (state: AppState) => getState(state).running;
